/**
 * CreatePage 草稿（session 级）：刷新不丢，关标签页清空。
 * 与 extraParamValues（localStorage，跨会话用户偏好）区分。
 */

export type CreatePageDraft = {
	prompt: string
	platformId: string
	modelId: string
	apiSize: string
	aspectRatio: string
	outputSuperResolution: boolean
	referenceAbsoluteUrls: string[]
}

const SESSION_DRAFT_KEY = 'glyphicai:create-page-draft:v1'

export const EMPTY_DRAFT: CreatePageDraft = {
	prompt: '',
	platformId: '',
	modelId: '',
	apiSize: '',
	aspectRatio: '16:9',
	outputSuperResolution: false,
	referenceAbsoluteUrls: [],
}

export function readCreatePageDraft(): CreatePageDraft | null {
	try {
		const raw = sessionStorage.getItem(SESSION_DRAFT_KEY)
		if (!raw) return null
		const parsed = JSON.parse(raw) as Partial<CreatePageDraft>
		// 基本类型守卫，避免 sessionStorage 被污染
		const draft: CreatePageDraft = {
			prompt: typeof parsed.prompt === 'string' ? parsed.prompt : EMPTY_DRAFT.prompt,
			platformId: typeof parsed.platformId === 'string' ? parsed.platformId : EMPTY_DRAFT.platformId,
			modelId: typeof parsed.modelId === 'string' ? parsed.modelId : EMPTY_DRAFT.modelId,
			apiSize: typeof parsed.apiSize === 'string' ? parsed.apiSize : EMPTY_DRAFT.apiSize,
			aspectRatio: typeof parsed.aspectRatio === 'string' ? parsed.aspectRatio : EMPTY_DRAFT.aspectRatio,
			outputSuperResolution:
				typeof parsed.outputSuperResolution === 'boolean'
					? parsed.outputSuperResolution
					: EMPTY_DRAFT.outputSuperResolution,
			referenceAbsoluteUrls: Array.isArray(parsed.referenceAbsoluteUrls)
				? parsed.referenceAbsoluteUrls.filter((u): u is string => typeof u === 'string')
				: EMPTY_DRAFT.referenceAbsoluteUrls,
		}
		return draft
	} catch {
		return null
	}
}

export function writeCreatePageDraft(draft: CreatePageDraft): void {
	try {
		sessionStorage.setItem(SESSION_DRAFT_KEY, JSON.stringify(draft))
	} catch {
		// sessionStorage 可能被禁用（隐私模式），忽略
	}
}

export function clearCreatePageDraft(): void {
	try {
		sessionStorage.removeItem(SESSION_DRAFT_KEY)
	} catch {
		// ignore
	}
}
